import {
	ReactElement,
	useContext,
	useMemo
} from "react";
import { ItemResponsiveBehavior } from "../CollapsibleList/CollapsibleList";
import { ToolbarItem } from "./ToolbarItem";
import { ToolbarContext, ToolbarPriority } from "./Toolbar";
import { ActionListDivider } from "../ActionList/ActionListDivider";
import styles from "./ToolbarDivider.module.less";
import { ButtonSize } from "../Button/Button";
import classNames from "classnames";

export type ToolbarDividerProps = {
	responsiveBehavior?: ItemResponsiveBehavior;
};

export const ToolbarDivider = (props: ToolbarDividerProps): ReactElement => {
	const {
		responsiveBehavior
	} = props;

	const { buttonSize } = useContext(ToolbarContext);

	const renderNormalMode = (): ReactElement => {
		return (
			<>
				<div
					className={classNames(
						styles.root,
						buttonSizeToStyleMap[buttonSize]
					)}
				>
					<div className={styles.divider} />
				</div>
			</>
		);
	};

	const renderCollapsedMode = (): ReactElement => {
		return (
			<ActionListDivider />
		);
	};

	const priority = useMemo(
		(): number => {
			if (responsiveBehavior === "hide") {
				return ToolbarPriority.LowPriorityItem;
			}

			return ToolbarPriority.Default;
		},
		[responsiveBehavior]
	);

	return (
		<ToolbarItem
			priority={priority}
			responsiveBehavior={responsiveBehavior}
			renderNormalMode={() => renderNormalMode()}
			renderCollapsedMode={() => renderCollapsedMode()}
		/>
	);
};
ToolbarDivider.displayName = "Toolbar.Toggle";

const buttonSizeToStyleMap: Record<ButtonSize, string | undefined> = {
	["normal"]: undefined,
	["large"]: styles.root_large
};
